<template>
    <div>
        <div class="duration-fields">
            <div class="input-group input-group-sm"><label class="sr-only" :for="id">Часы</label><input :id="id" class="form-control" type="text" inputmode="numeric" :value="hours" :disabled="disabled" :aria-invalid="Boolean(error)" :aria-describedby="error ? `${id}-error` : null" @input="update('hours', $event.target.value)"><span class="input-group-append" aria-hidden="true"><span class="input-group-text">ч</span></span></div>
            <div class="input-group input-group-sm"><label class="sr-only" :for="`${id}-minutes`">Минуты</label><input :id="`${id}-minutes`" class="form-control" type="text" inputmode="numeric" :value="minutes" :disabled="disabled" :aria-invalid="Boolean(error)" :aria-describedby="error ? `${id}-error` : null" @input="update('minutes', $event.target.value)"><span class="input-group-append" aria-hidden="true"><span class="input-group-text">мин</span></span></div>
        </div>
        <small v-if="error" :id="`${id}-error`" class="text-danger" role="status">{{ error }}</small>
    </div>
</template>
<script>
import sources from './payrollSourcePresentation';
export default {
    name: 'PayrollDurationInput',
    props: {id: {type: String, required: true}, value: String, disabled: Boolean},
    data() { return {hours: '', minutes: '', emitted: null}; },
    computed: {
        canonical() { return `${this.hours}:${/^\d$/.test(this.minutes) ? `0${this.minutes}` : this.minutes}`; },
        error() { try { sources.parseQuantity(this.canonical, 'accepted_minutes'); return ''; } catch (error) { return error.message; } }
    },
    watch: {value: {immediate: true, handler(value) { this.sync(value); }}},
    methods: {
        sync(value) {
            // Parent echoes must not replace partial input or move the caret.
            if (value === this.emitted) return;
            const [hours, minutes] = String(value == null ? '' : value).split(':');
            this.hours = hours; this.minutes = minutes == null ? '' : minutes; this.emitted = null;
        },
        update(field, value) { this[field] = value; this.emitted = this.canonical; this.$emit('input', this.emitted); }
    }
};
</script>
<style scoped>
.duration-fields { display: flex; gap: 8px; }
.duration-fields > div { min-width: 0; flex: 1; }
.duration-fields > div:last-child { flex: 0 1 85px; }
.input-group-text { padding-left: 6px; padding-right: 6px; color: #586b7d; background: #fff; }
small { display: block; margin-top: 3px; }
</style>
